// forfreelance3@gmail.com
// Forfreelance@3

import React, { useEffect, useRef, useState } from "react";
import "./Contact.scss";
import Footer from "../../Components/footer/Footer";
import Navbar from "../../Components/Navbar/Navbar";
import locationData from "../../Data/Location.json";

const Contacts = () => {
  const [loading, setLoading] = useState(false);
  const messageRef = useRef();
  const formRef = useRef();
  const scriptUrl =
    "https://script.google.com/macros/s/AKfycbx-WaEvl_7EwxBjE8hmw9uMIGLSeywExfb91zyjWnEnNPxEOgXnNI3mgzYxh2qQlMYqTQ/exec";

  const handleSubmit = (e) => {
    setLoading(true);
    e.preventDefault();

    fetch(scriptUrl, { method: "POST", body: new FormData(formRef.current) })
      .then((res) => {
        setLoading(false);
        messageRef.current.value = "";
        console.log("submitted");
      })
      .catch((err) => console.log(err, "error detected"));
  };

  console.log(new FormData(formRef.current));
  useEffect(()=>{
    window.scrollTo(0,0)
},[])
  return (
    <div className="contacts-page">
      <Navbar />
      <div className="contact">
        <div className="contact-box">
          {" "}
          {/* the contact box as cente */}
          <div className="contact-box-titleandmap">
            {/* it for map and title */}
            <div className="contact-box-titleandmap-title">
              <h2>for enquiry</h2>
            </div>
            <div className="contact-box-titleandmap-map">
              {/* <MyComponent/> */}
              <iframe
                title="location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d982.3995645612623!2d76.33795965250624!3d9.967343769107885!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b087337b2957c27%3A0x918614675732b4b!2sLakshmi%20Upholstery%20Works%20Eroor!5e0!3m2!1sen!2sin!4v1652099248298!5m2!1sen!2sin"
                width="100%"
                height="100%"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
          <div className="contact-box-form">
            {/* it for from */}
            {/* <form ref={formRef} onSubmit={handleSubmit}> */}
            <form onSubmit={handleSubmit} ref={formRef}>
              <input
                type="text"
                name="firstname"
                className=" fname"
                placeholder="full name"
                required
              />
              <input
                type="number"
                name="phonenumber"
                className="phone"
                placeholder="phone number"
              />
              <select name="location" className="location">
                <option selected disabled hidden value="none">
                  location
                </option>
                {locationData.map((data) => (
                  <option value={data.Location}>{data.Location}</option>
                ))}
              </select>
              <input
                type="email"
                name="email"
                className="email"
                placeholder="email"
              />
              <textarea
                placeholder="message"
                name="message"
                className="msg"
                id=""
                rows="10"
                required
                ref={messageRef}
              ></textarea>
              <div className="time">
                Are you planning immediatly ? <br />
                <div style={{ display: "flex", alignItems: "center" }}>
                  <input checked  type="radio" name="planning_immediate" value="yes" />
                  <label style={{marginLeft:"5px"}} htmlFor="">Yes</label>
                  <input style={{marginLeft:"10px"}} type="radio" name="planning_immediate" value="no" />
                  <label style={{marginLeft:"5px"}} htmlFor="">No</label>
                </div>
              </div>
              <button type="submit" name="sendbutton" className="btn">
                {loading ? "Loading..." : "SEND"}
              </button>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Contacts;
